import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advancedFormat from "dayjs/plugin/advancedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import customParseFormat from "dayjs/plugin/customParseFormat";
import type { App } from "vue";
import minMax from "dayjs/plugin/minMax";

function installPlugins() {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(advancedFormat);
  dayjs.extend(duration);
  dayjs.extend(relativeTime);
  dayjs.extend(customParseFormat);
  dayjs.extend(minMax);

  return dayjs;
}

export const Dayjs = installPlugins();

export default {
  install(app: App) {
    app.config.globalProperties.$dayjs = installPlugins();
  },
};
